import { createSlice } from "@reduxjs/toolkit";
import { InitialState, Reducers, USER } from "../../constants/user";
import { RootState } from "../";

const initialState: InitialState = {
  userId: localStorage.getItem("userId"),
  firstName: "Enrico",
  middleName: "Dela Cruz",
  lastName: "Cristobal",
  email: "test@test.com",
  number: "1234567801",
  address: "Test Location",
  token: localStorage.getItem("token"),
  description: "",
  memberSince: "",
};

const reducers: Reducers = {
  setUserId: (state, action) => {
    state.userId = action.payload.userId;
  },
  setToken: (state, action) => {
    state.token = action.payload.token;
  },
  setUserInfo: (state, action) => {
    state.firstName = action.payload.firstName;
    state.middleName = action.payload.middleName;
    state.lastName = action.payload.lastName;
    state.email = action.payload.email;
    state.number = action.payload.number;
    state.address = action.payload.address;
    state.memberSince = action.payload.createdAt;
  },
};

const userSlice = createSlice({
  name: USER,
  initialState,
  reducers,
});

export const userState = (state: RootState) => state.user;
export const { setUserId, setToken, setUserInfo } = userSlice.actions;
export default userSlice;
